import { useRef, useState } from 'react';

type UseAbandonChangesGuardArgs = {
  isDirty: boolean;
  onClose: () => void;
};

export const useAbandonChangesGuard = ({
  isDirty,
  onClose,
}: UseAbandonChangesGuardArgs) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const cancelRef = useRef<HTMLButtonElement | null>(null);

  const requestClose = () => {
    if (isDirty) {
      setIsConfirmOpen(true);
      return;
    }
    onClose();
  };

  const confirmAbandon = () => {
    setIsConfirmOpen(false);
    onClose();
  };

  const cancelAbandon = () => {
    setIsConfirmOpen(false);
  };

  return {
    requestClose,
    isConfirmOpen,
    confirmAbandon,
    cancelAbandon,
    cancelRef,
  };
};
